import { BaseMultiText } from '../../../translation';
import { currentBuilderState } from '../builder.state';
import { MAX_SELECTABLE_METRICS } from '../const/max-selectable-metrics.const';

import { updateRouterQueryParams } from './update-router-query-params.function';
import { updateSectionLabels } from './update-section-labels.function';

export function selectMetric(m: BaseMultiText): void {
    const state = currentBuilderState();

    state.viewParams.metricLookup ??= {};
    state.viewParams.metricLookup[m.id] = true;
    state.viewParams.metrics ??= [];
    state.viewParams.metrics.push(m);

    state.cannotSelectMetrics =
        state.viewParams.metrics?.length >= MAX_SELECTABLE_METRICS;

    updateSectionLabels();
    updateRouterQueryParams();
}
